// The *Unassigned faces* tab of the identities page (PRD-0031 slice 04): the shared
// selection shell around the pure grid. A viewer gets the list without the actions
// (PRD-0032 SC-036); "Play pass" on a recording's card opens the recording at that
// pass in the document overlay (PRD-0074 slice 04).

import { useDocumentOverlayOptional } from '@/components/document-overlay/overlay-context'
import { UnassignedFacesGrid } from '@/components/identities/UnassignedFacesGrid'
import { canDecideFaces } from '@/features/face-matching/decision-role'
import { useUnassignedFaces } from './hooks/useUnassignedFaces'
import { UnassignedSelectionShell } from './UnassignedSelectionShell'

interface UnassignedFacesTabProps {
  caseId: string
}

export function UnassignedFacesTab({ caseId }: UnassignedFacesTabProps) {
  const faces = useUnassignedFaces(caseId)
  const overlay = useDocumentOverlayOptional()
  return (
    <UnassignedSelectionShell
      caseId={caseId}
      copy="identity.unassigned"
      selection={faces}
      canDecide={canDecideFaces(faces.data?.member_role)}
    >
      <UnassignedFacesGrid
        faces={faces.faces}
        isLoading={faces.isLoading}
        isSelected={faces.isSelected}
        onToggle={faces.toggle}
        onPlayPass={
          overlay
            ? face => {
                if (face.document_id) {
                  overlay.open({ documentId: face.document_id, faceId: face.face_id, play: true })
                }
              }
            : undefined
        }
      />
    </UnassignedSelectionShell>
  )
}
